import { Dialog } from '@base-ui/react/dialog'
import type { ReactNode } from 'react'
import { Icon } from '@/components/icons/icon'

interface DrawerProps {
  open: boolean
  onClose: () => void
  /** The h2 in the head. Also the dialog's accessible name. */
  title: ReactNode
  /** The quiet line under the title (`.small.faint`), e.g. "C-1842 · Today 2:36pm · 5m 12s". */
  meta?: ReactNode
  /** Between the title and the close button, e.g. the outcome badge. */
  headExtra?: ReactNode
  /** Names the close button, e.g. "Close call detail". */
  closeLabel?: string
  children: ReactNode
  /** The sticky action row at the bottom (`.drawer-f`). */
  footer?: ReactNode
}

/**
 * The right-hand detail panel (`.drawer` + `.scrim`), 520px wide, full width on
 * mobile. Slides in and out like the prototype; Base UI's Dialog supplies the
 * focus trap, Escape, scrim click and focus return.
 */
export function Drawer({ open, onClose, title, meta, headExtra, closeLabel = 'Close', children, footer }: DrawerProps) {
  return (
    <Dialog.Root open={open} onOpenChange={(next) => (next ? undefined : onClose())}>
      <Dialog.Portal className="console-layer">
        <Dialog.Backdrop className="scrim on" />
        <Dialog.Popup className="drawer on">
          <div className="drawer-h">
            <div style={{ minWidth: 0, flex: 1 }}>
              <Dialog.Title render={<h2 style={{ fontSize: '1rem' }} />}>{title}</Dialog.Title>
              {meta ? <p className="small faint">{meta}</p> : null}
            </div>
            {headExtra}
            <Dialog.Close className="iconbtn" aria-label={closeLabel}>
              <Icon name="x" />
            </Dialog.Close>
          </div>
          <div className="drawer-b">{children}</div>
          {footer ? <div className="drawer-f">{footer}</div> : null}
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
